module.exports = __webpack_public_path__ + "img/list-tip.a4ac8045.svg";